import { type ComponentProps, Suspense } from 'react';
import { MeetingConcernsTable } from './MeetingConcernsTable';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useMeetingConcernsShowSuspenseQuery } from './MeetingConcernsShow.graphql';

const MeetingConcernsShowInner = ({ meetingId }: { meetingId: string }) => {
  const companyId = useCompanyId();

  const {
    data: { meetingConcerns },
  } = useMeetingConcernsShowSuspenseQuery({ variables: { companyId, meetingId }, fetchPolicy: 'no-cache' });

  return <MeetingConcernsTable meetingConcerns={meetingConcerns} />;
};

export const MeetingConcernsShow = (props: ComponentProps<typeof MeetingConcernsShowInner>) => {
  return (
    <Suspense>
      <MeetingConcernsShowInner {...props} />
    </Suspense>
  );
};
